var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tempGraph)?_c('fusioncharts',{attrs:{"width":"100%","height":"470","type":"zoomline","dataFormat":"json","dataSource":_vm.dataSourceTemp}}):_vm._e(),(_vm.humiGraph)?_c('fusioncharts',{attrs:{"width":"100%","height":"470","type":"zoomline","dataFormat":"json","dataSource":_vm.dataSourceHumi}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }